import { useQuery } from '@tanstack/react-query';

import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

interface ContactInfoEnabledResponse {
  enabled: boolean;
}

export function useIsContactInfoEnabled() {
  const [isArtistContactsEnabled] = useFeatureFlags([
    FEATURE_FLAGS.WmgArtistContacts,
  ]);

  const { data, isLoading, error } = useQuery({
    queryKey: ['contact-info-enabled'],
    queryFn: async () => {
      const res = await fetch('/api/roster/contact_info_enabled');

      if (!res.ok) {
        throw new Error('Failed to fetch contact-info flag');
      }

      const json: ContactInfoEnabledResponse = await res.json();

      return json.enabled;
    },
    enabled: isArtistContactsEnabled,
  });

  return {
    enabled: !!data,
    isLoading,
    error,
  };
}
